import {
  Button,
  Container,
  Modal,
  Box,
  Typography,
  Divider,
} from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { getdoc, upload } from '../../../components/api'
import { FaSpinner } from 'react-icons/fa'

export default function MarcaImagem({
  dsTokenArquivo,
  dsTokenArquivoResposta,
  onUploadComplete,
  disabled = false,
}) {
  const canvasRef = useRef(null)

  const [loading, setLoading] = useState(true)
  const [isUploading, setIsUploading] = useState(false)
  const [fileUrl, setFileUrl] = useState(null)
  const [fileUrlResposta, setFileUrlResposta] = useState(null)

  const [opened, setOpened] = useState(false)
  const [brushSize] = useState(15)
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 })
  const [isDrawing, setIsDrawing] = useState(false)

  const loadDocument = async (token) => {
    setLoading(true)

    try {
      const response = await getdoc(token)

      if (typeof response.blob !== 'function') {
        console.error('Resposta inválida para blob()')
        setLoading(false)
        return
      }

      const blob = await response.blob()
      const url = URL.createObjectURL(blob)

      setFileUrl(url)
    } catch (err) {
      console.error('Erro ao carregar documento:', err)
    }

    setLoading(false)
  }

  const loadDocumentResposta = async (token) => {
    setLoading(true)

    try {
      const response = await getdoc(token)

      if (typeof response.blob !== 'function') {
        console.error('Resposta inválida para blob()')
        setLoading(false)
        return
      }

      const blob = await response.blob()
      const url = URL.createObjectURL(blob)

      setFileUrlResposta(url)
    } catch (err) {
      console.error('Erro ao carregar documento:', err)
    }

    setLoading(false)
  }

  useEffect(() => {
    loadDocument(dsTokenArquivo)
    if (dsTokenArquivoResposta) {
      loadDocumentResposta(dsTokenArquivoResposta)
    }
  }, [dsTokenArquivo, dsTokenArquivoResposta])

  const drawPoint = (x, y) => {
    const ctx = canvasRef.current.getContext('2d')

    ctx.beginPath()
    ctx.arc(x, y, brushSize / 2, 0, Math.PI * 2)
    ctx.fillStyle = 'red'
    ctx.fill()
  }

  const handleMouseMove = (e) => {
    const rect = canvasRef.current.getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top

    setMousePos({ x, y })

    if (isDrawing) {
      drawPoint(x, y)
    }
  }

  const handleMouseDown = (e) => {
    setIsDrawing(true)

    const rect = canvasRef.current.getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top

    drawPoint(x, y)
  }

  const handleMouseUp = () => {
    setIsDrawing(false)
  }

  const handleExport = () => {
    exportImage()
    setOpened(false)
  }

  const handleCancel = () => {
    const canvas = canvasRef.current
    const ctx = canvas.getContext('2d')

    ctx.clearRect(0, 0, canvas.width, canvas.height)
    setOpened(false)
  }

  const exportImage = () => {
    const canvas = canvasRef.current
    const img = new window.Image()

    img.src = fileUrl

    img.onload = () => {
      const tempCanvas = document.createElement('canvas')
      const ctx = tempCanvas.getContext('2d')

      tempCanvas.width = img.naturalWidth
      tempCanvas.height = img.naturalHeight

      ctx.drawImage(img, 0, 0)

      const scaleX = img.naturalWidth / canvas.width
      const scaleY = img.naturalHeight / canvas.height

      ctx.drawImage(
        canvas,
        0,
        0,
        canvas.width,
        canvas.height,
        0,
        0,
        canvas.width * scaleX,
        canvas.height * scaleY,
      )

      // 👇 CONVERSÃO PARA FILE
      tempCanvas.toBlob((blob) => {
        if (!blob) return

        const file = new File([blob], 'imagem-marcada.png', {
          type: 'image/png',
        })

        // 👇 ENVIA PARA SUA FUNÇÃO
        enviarArquivos([file])
      }, 'image/png')
    }
  }

  const enviarArquivos = async (files) => {
    try {
      setIsUploading(true)

      const response = await upload(files, '/questionario/', false)

      if (!response.status) {
        throw new Error(response.dsErro)
      }

      const data = await response
      onUploadComplete(data)
    } catch (err) {
      const erro = { dsErro: err.message }
      onUploadComplete(erro)
    } finally {
      setIsUploading(false)
    }
  }

  return (
    <Container maxWidth="sm" style={{ marginTop: 40 }}>
      {loading ? (
        <>Carregando</>
      ) : (
        <>
          <img
            src={fileUrlResposta || fileUrl}
            alt="Preview"
            style={{
              cursor: disabled === true ? '' : 'pointer',
              maxWidth: '100%',
            }}
            onClick={() => (disabled === true ? '' : setOpened(true))}
          />

          <Modal
            open={opened}
            onClose={(event, reason) => {
              if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                return
              }
              setOpened(false)
            }}
          >
            <Box
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: '#fff',
                padding: 20,
                outline: 'none',
                width: '90vw',
                maxWidth: '1400px',
                maxHeight: '90vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography
                variant="h8"
                style={{ whiteSpace: 'pre-line' }}
                sx={{ mb: 2 }}
              >
                Utilize o mouse ou toque na imagem para marcar os pontos
                desejados
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <div style={{ position: 'relative', display: 'inline-block' }}>
                <img
                  src={fileUrl}
                  alt="Imagem"
                  style={{ display: 'block', maxWidth: '100%' }}
                  onLoad={(e) => {
                    const canvas = canvasRef.current
                    const img = e.target

                    canvas.width = img.width
                    canvas.height = img.height
                  }}
                />

                <canvas
                  ref={canvasRef}
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    cursor: 'none',
                  }}
                  onMouseMove={handleMouseMove}
                  onMouseDown={handleMouseDown}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={handleMouseUp}
                />

                <div
                  style={{
                    position: 'absolute',
                    left: mousePos.x - brushSize / 2,
                    top: mousePos.y - brushSize / 2,
                    width: brushSize,
                    height: brushSize,
                    borderRadius: '50%',
                    border: '2px solid red',
                    background: 'rgba(255,0,0,0.1)',
                    pointerEvents: 'none',
                  }}
                />
              </div>

              <div style={{ marginTop: 10, display: 'flex', gap: 10 }}>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleCancel}
                >
                  Limpar
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={handleCancel}
                >
                  Cancelar
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleExport}
                  startIcon={isUploading ? <FaSpinner /> : ''}
                >
                  Confirmar marcações
                </Button>
              </div>
            </Box>
          </Modal>
        </>
      )}
    </Container>
  )
}
